import React from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import './ProductCard.css';

export default function ProductCard({ product }) {
  const { addItem } = useCart();
  const imageUrl = product.images?.[0]
    ? (product.images[0].startsWith('http') ? product.images[0] : product.images[0])
    : null;

  return (
    <div className="product-card">
      <Link to={`/product/${product.id}`} className="product-image-link">
        <div className="product-image">
          {imageUrl ? (
            <img src={imageUrl} alt={product.title} />
          ) : (
            <div className="product-no-image">📦</div>
          )}
        </div>
        {product.condition && (
          <span className={`condition-badge condition-${product.condition.toLowerCase().replace(' ', '-')}`}>
            {product.condition}
          </span>
        )}
        {product.on_sale && (
          <span className="sale-badge">-{product.sale_percent}%</span>
        )}
      </Link>

      <div className="product-info">
        <Link to={`/product/${product.id}`}>
          <h3 className="product-title">{product.title}</h3>
        </Link>
        {product.category && <p className="product-category">{product.category}</p>}
        <p className="product-shipping-hint">Live UPS, USPS, and FedEx rates on item page</p>
        <div className="product-footer">
          <div className="product-price-stack">
            <span className="product-price">${parseFloat(product.price).toFixed(2)}</span>
            {product.on_sale && (
              <span className="product-price-compare">${parseFloat(product.base_price).toFixed(2)}</span>
            )}
          </div>
          {product.quantity > 0 ? (
            <button
              className="btn btn-primary btn-sm"
              onClick={() => addItem(product)}
            >
              Add to Cart
            </button>
          ) : (
            <span className="out-of-stock">Out of Stock</span>
          )}
        </div>
      </div>
    </div>
  );
}
